module.exports = __webpack_public_path__ + "img/list-disc.07e3fad3.svg";